/* MANIERE · ficha de producto: galería, tallas/colores y añadir al carrito */
(function () {
  if (window.__mnTienda) return;
  window.__mnTienda = true;

  var marca = function (el) {
    if (!el || el.dataset.mnT) return false;
    el.dataset.mnT = '1';
    return true;
  };

  /* ---------- galería ---------- */
  function mostrarFoto(galeria, i) {
    galeria.querySelectorAll('.mn-pdp__foto').forEach(function (f) {
      f.classList.toggle('mn-on', f.dataset.mnFoto === String(i));
    });
    galeria.querySelectorAll('.mn-pdp__mini').forEach(function (m) {
      m.classList.toggle('mn-on', m.dataset.mnMini === String(i));
    });
  }

  function initGaleria() {
    document.querySelectorAll('[data-mn-galeria]').forEach(function (g) {
      if (!marca(g)) return;
      g.querySelectorAll('.mn-pdp__mini').forEach(function (mini) {
        mini.addEventListener('click', function () {
          mostrarFoto(g, mini.dataset.mnMini);
        });
      });
    });
  }

  /* ---------- variantes ---------- */
  function initCompra() {
    document.querySelectorAll('[data-mn-compra]').forEach(function (caja) {
      if (!marca(caja)) return;

      var fuente = caja.querySelector('[data-mn-variantes]');
      if (!fuente) return;
      var variantes = [];
      try {
        variantes = JSON.parse(fuente.textContent);
      } catch (e) {
        return;
      }
      if (!variantes.length) return;

      var seccion = caja.closest('.shopify-section') || document;
      var galeria = seccion.querySelector('[data-mn-galeria]');
      var precio = caja.querySelector('[data-mn-precio]');
      var antes = caja.querySelector('[data-mn-antes]');
      var oferta = caja.querySelector('[data-mn-oferta]');
      var campoId = caja.querySelector('[data-mn-vid]');
      var boton = caja.querySelector('[data-mn-add]');
      var botonTxt = caja.querySelector('[data-mn-addtxt]');
      var comprar = caja.querySelector('[data-mn-comprar]');
      var grupos = caja.querySelectorAll('.mn-pdp__op');

      /* aviso de pocas unidades: solo se enseña si el inventario real de la
         variante elegida esta por debajo del umbral */
      var pocas = caja.querySelector('[data-mn-pocas]');
      var pocasT = pocas ? pocas.querySelector('[data-mn-pocas-t]') : null;
      var pocasUmbral = pocas ? parseInt(pocas.dataset.mnPocasUmbral || '0', 10) : 0;
      var pocasPlantilla = pocas ? pocas.dataset.mnPocasPlantilla || '' : '';
      /* numero de prueba: si esta puesto manda sobre el stock real (solo sirve
         para ver como queda el aviso; en la tienda de verdad va a 0) */
      var pocasDemo = pocas ? parseInt(pocas.dataset.mnPocasDemo || '0', 10) : 0;

      function pintarPocas(variante) {
        if (!pocas) return;
        var u = variante && variante.disponible ? variante.stock || 0 : 0;
        if (pocasDemo > 0 && variante && variante.disponible) u = pocasDemo;
        if (u > 0 && (pocasDemo > 0 || (pocasUmbral > 0 && u <= pocasUmbral))) {
          if (pocasT) {
            /* el numero va dentro de un <b> para que destaque, asi que se
               monta con nodos en vez de con textContent */
            var trozos = pocasPlantilla.split('{unidades}');
            var fuerte = document.createElement('b');
            fuerte.textContent = u;
            pocasT.textContent = '';
            pocasT.appendChild(document.createTextNode(trozos[0] || ''));
            pocasT.appendChild(fuerte);
            pocasT.appendChild(document.createTextNode(trozos[1] || ''));
          }
          pocas.hidden = false;
        } else {
          pocas.hidden = true;
        }
      }
      var textos = {
        anadir: (boton && boton.dataset.mnAnadir) || 'Añadir al carrito',
        agotado: (boton && boton.dataset.mnAgotado) || 'Agotado'
      };

      function seleccion() {
        var vals = [];
        grupos.forEach(function (g) {
          var on = g.querySelector('.mn-pdp__ov.mn-on');
          vals.push(on ? on.dataset.mnValor : null);
        });
        return vals;
      }

      function buscar(vals) {
        return variantes.find(function (v) {
          return v.opciones.every(function (o, i) {
            return o === vals[i];
          });
        });
      }

      function pintarDisponibilidad(vals) {
        grupos.forEach(function (g, gi) {
          g.querySelectorAll('.mn-pdp__ov').forEach(function (btn) {
            var prueba = vals.slice();
            prueba[gi] = btn.dataset.mnValor;
            var hay = variantes.some(function (v) {
              return (
                v.disponible &&
                v.opciones.every(function (o, i) {
                  return i === gi ? o === prueba[gi] : prueba[i] === null || o === prueba[i];
                })
              );
            });
            btn.classList.toggle('mn-agotado', !hay);
          });
        });
      }

      function refrescar() {
        var vals = seleccion();
        var v = buscar(vals);

        grupos.forEach(function (g, gi) {
          var eti = g.querySelector('[data-mn-opsel]');
          if (eti) eti.textContent = vals[gi] || '';
        });

        pintarDisponibilidad(vals);

        if (!v) {
          if (boton) boton.disabled = true;
          if (botonTxt) botonTxt.textContent = textos.agotado;
          if (comprar) comprar.hidden = true;
          pintarPocas(null);
          return;
        }

        if (campoId) campoId.value = v.id;
        if (precio) precio.textContent = v.precio;
        if (antes) {
          antes.textContent = v.antes;
          antes.hidden = !v.rebajado;
        }
        /* el cartel de oferta: se reescribe y se vuelve a animar en cada
           cambio de variante, para que el ojo lo pille tambien al elegir
           otro color o talla */
        if (oferta) {
          var textoOferta = v.oferta || '';
          oferta.textContent = textoOferta;
          oferta.hidden = !textoOferta;
          if (textoOferta) {
            oferta.style.animation = 'none';
            /* forzar reflow para poder relanzar la animacion */
            void oferta.offsetWidth;
            oferta.style.animation = '';
          }
        }
        if (boton) boton.disabled = !v.disponible;
        if (botonTxt) botonTxt.textContent = v.disponible ? textos.anadir : textos.agotado;
        if (comprar) comprar.hidden = !v.disponible;
        pintarPocas(v);
        if (galeria && v.foto >= 0) mostrarFoto(galeria, v.foto);

        /* aviso para el resto de la ficha (la barra de urgencia lo escucha
           para reescribir descuento y unidades de ESTA variante) */
        try {
          document.dispatchEvent(new CustomEvent('mn:variante', { detail: v }));
        } catch (e) {
          /* navegador antiguo: la barra se queda con el dato de la carga */
        }

        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        } catch (e) {
          /* da igual: es solo la dirección de la barra */
        }
      }

      grupos.forEach(function (g) {
        g.querySelectorAll('.mn-pdp__ov').forEach(function (btn) {
          btn.addEventListener('click', function () {
            g.querySelectorAll('.mn-pdp__ov').forEach(function (o) {
              o.classList.remove('mn-on');
            });
            btn.classList.add('mn-on');
            refrescar();
          });
        });
      });

      if (grupos.length) refrescar();

      /* ---------- añadir al carrito ---------- */
      var form = caja.querySelector('.mn-pdp__form');
      var error = caja.querySelector('[data-mn-error]');
      var cajon = document.querySelector('cart-drawer');
      if (!form || !cajon || !window.routes || !window.routes.cart_add_url) return;

      form.addEventListener('submit', function (ev) {
        ev.preventDefault();
        if (boton && boton.disabled) return;
        if (error) {
          error.hidden = true;
          error.textContent = '';
        }
        if (boton) boton.classList.add('mn-cargando');

        var datos = new FormData(form);
        datos.append('sections', 'cart-drawer,cart-icon-bubble');
        datos.append('sections_url', window.location.pathname);

        fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: { Accept: 'application/javascript' },
          body: datos
        })
          .then(function (r) {
            return r.json();
          })
          .then(function (res) {
            if (res.status) throw new Error(res.description || res.message);
            if (res.sections) {
              cajon.classList.remove('is-empty');
              cajon.renderContents(res);
            } else {
              window.location.href = window.routes.cart_url;
            }
          })
          .catch(function (err) {
            if (error) {
              error.textContent = err.message || 'No se ha podido añadir. Inténtalo otra vez.';
              error.hidden = false;
            } else {
              form.submit();
            }
          })
          .then(function () {
            if (boton) boton.classList.remove('mn-cargando');
          });
      });

      /* ---------- comprar ahora: al carrito y directo al pago ---------- */
      if (comprar) {
        var comprarTxt = comprar.querySelector('[data-mn-comprartxt]');
        var textoComprar = comprarTxt ? comprarTxt.textContent : '';
        var urlPago =
          (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
            ? window.Shopify.routes.root
            : '/') + 'checkout';

        comprar.addEventListener('click', function () {
          if (comprar.disabled || comprar.hidden) return;
          if (error) {
            error.hidden = true;
            error.textContent = '';
          }
          comprar.disabled = true;
          comprar.classList.add('mn-cargando');
          if (comprarTxt && comprar.dataset.mnComprando) {
            comprarTxt.textContent = comprar.dataset.mnComprando;
          }

          var datos = new FormData(form);

          fetch(window.routes.cart_add_url, {
            method: 'POST',
            headers: { Accept: 'application/javascript' },
            body: datos
          })
            .then(function (r) {
              return r.json();
            })
            .then(function (res) {
              if (res.status) throw new Error(res.description || res.message);
              window.location.href = urlPago;
            })
            .catch(function (err) {
              if (error) {
                error.textContent =
                  err.message || 'No se ha podido continuar. Inténtalo otra vez.';
                error.hidden = false;
              }
              comprar.disabled = false;
              comprar.classList.remove('mn-cargando');
              if (comprarTxt) comprarTxt.textContent = textoComprar;
            });
        });
      }
    });
  }

  function initTodo() {
    initGaleria();
    initCompra();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTodo);
  } else {
    initTodo();
  }
  document.addEventListener('shopify:section:load', initTodo);
})();
